export default "__VITE_ASSET__CZVrc9rV__"